import { titleCase } from 'functions/capitalize';
import { frameShapeToName } from 'functions/frameShapeToName';

interface CategoryTitleProps {
  colour?: string
  type?: string
  frequency?: string
  brand?: string
  query: {
    colour?: string | string[]
    shape?: string | string[]
  }
}


export function getColourTitle(colour: string | string[]): string | null {

  const name =
    (colour && Array.isArray(colour) ?
      colour.join(' & ') :
      colour);

  return titleCase(name || '');
}

export function getCategoryTitle({ colour, type, frequency, brand, query }: CategoryTitleProps): string | null {
  if (!(colour || type || frequency || brand ||
    (query.colour && typeof query.colour === 'string') ||
    (query.shape && typeof query.shape === 'string'))) {
    return null;
  }

  const shouldShowColor = !query.colour || !Array.isArray(query.colour) || query.colour.length <= 1;
  const name = colour || type || frequency || brand || (shouldShowColor && query.colour && getColourTitle(query.colour));

  const shape = query.shape ? frameShapeToName(query.shape as string) : null;

  return `${name ? titleCase(name) : ''} ${shape ? `${shape} ` : ''} `;
}

